/* 运营中心-乘客订单 */
<template>
  <div id="order">

    <div v-if="printRow.startStationName" id="print" style="display: none;">
      <div style="padding-top: 92px;font-size:10px;display: inline-block;">
        <div style="margin-left:215px;height: 16px;">
          <span style="display: inline-block;width: 60px;vertical-align: top;">{{ printRow.startStationName }}</span>
          <span style="margin-left:10px;width: 60px;display: inline-block;vertical-align: top;">{{
              printRow.endStationName
            }}</span>
          <span style="margin-left:40px">{{ printRow.ticketFee }}</span>
        </div>
        <div style="margin:5px 0 0 80px">
          <span>{{ printRow.startLineTime }}</span>
          <span style="margin-left:12px">{{ printRow.licenseNo }}</span>
          <span style="margin-left:140px;;position: relative;top: 5px;">{{ printRow.ticketFee }}</span>
        </div>
        <div style="margin:25px 0 0 50px">
          <span>{{ $utils.timeFn(Date.parse(new Date()), 'YYYY.MM.DD') }}</span>
          <span style="margin-left:10px;display: inline-block;min-width:20px;">{{ printRow.ticketFee }}</span>
          <span style="margin-left:8px;display: inline-block;width:48px;vertical-align: top;">{{
              printRow.ticketSeller
            }}</span>
          <span style="margin-left:25px">{{ $utils.timeFn(printRow.schedulingTime, 'YYYY.MM.DD') }}</span>
          <span style="margin-left:35px">{{ printRow.startLineTime }}</span>
          <span style="margin-left:15px">{{ printRow.licenseNo }}</span>
          <span style="margin-left:15px">{{ printRow.seatNo }}</span>
        </div>
        <div style="margin:5px 0 0 0">
          <span style="margin-left: 100px"> {{ printRow.ticketType | filterConst('TICKETTYPE') }}</span>
          <span style="margin-left: 100px">{{ printRow.idCard.replace($const.CARDRULES[printRow.cardType || 1].defaultReg, $const.CARDRULES[printRow.cardType || 1].defaultReplace) }}</span> <span
            style="margin-left: 20px;">{{ printRow.customerName }}</span>
          <span style="margin-left: 10px"> {{ printRow.ticketType | filterConst('TICKETTYPE') }}</span>
        </div>
      </div>
    </div>

    <!--    <el-radio-group  v-model="tabAction" style="margin-bottom: 15px;">-->
    <!--      <el-radio-button label="all">全部</el-radio-button>-->
    <!--      <el-radio-button v-for="item in $const.ORDERSTATUS" :key="item.value" :label="item.value">-->
    <!--        {{ item.label }}-->
    <!--      </el-radio-button>-->
    <!--    </el-radio-group>-->

    <el-radio-group v-model="tabAction" style="margin-bottom: 15px;">
      <el-radio-button label="all">全部</el-radio-button>
      <el-radio-button v-for="item in $const.ORDERSTATUS2" :key="item.value" :label="item.value">
        {{ item.label }}
      </el-radio-button>
    </el-radio-group>


    <custom-table has-organization="true" ref="customTable" :customOptions="customOptions" :columns="columns"
                  :exportType="[{start:'startTime',end:'endTime', text: '请选择下单起止时间或完单起止时间'},{start:'finishStartTime', end:'finishEndTime', text: '请选择下单起止时间或完单起止时间'}]"
                  :export-required-fields="[{ prop: 'startTime', text: '请选择下单开始时间-下单结束时间' }, { prop: 'endTime', text: '请选择下单开始时间-下单结束时间' }]"
                  hasChildren="passengerNum" loadChildrenId="id" :loadChildren="loadChildren" excel-type="OrderLine"
                  labelWidth="135" style="height: 95%">
      <template slot="table-operation">
        <el-table-column label="操作" width="100" fixed="right" align="center">
          <div slot-scope="{ row }" class="custom-action">
            <el-button type="text"
                       v-if="(row.status == 1 || ((row.status == 5 || row.status == 10) && !['tc_order','station_order','system_order'].includes(row.channelAlias)))" 
                       @click="cancelClick(row)">退票
            </el-button>
            <el-button v-if="row.status == 10 && !['station_order', 'tc_order'].includes(row.channelAlias)" type="text"
                       @click="reassignmentClick(row)">改派
            </el-button>
          </div>
        </el-table-column>
      </template>

      <template slot-scope="{ item, row }">
        <template v-if="item.prop == 'created'">{{ row.created | filterTime }}</template>
        <template v-else-if="item.prop == 'finishTime'">{{ row.finishTime | filterTime }}</template>
        <template v-else-if="item.prop == 'orderNo'">
          <!-- <el-tag v-if="row.isTicketChanging == 1"
            style="margin-right: 8px;color: #ff9900;border-color: #ff9900;background: white;">改签
          </el-tag> -->
          <span class="link" @click="orderView = row; detailsVisible = true;">{{ row.orderNo }}</span>
        </template>
        <template v-else-if="item.prop == 'passengerNum'">
          <el-button type="text" style="text-decoration: underline;" @click="handleConnectionSearch(row)">
            {{ row.passengerNum }}
          </el-button>
        </template>
        <template v-else-if="item.prop == 'cardType'">
          <span v-if="row.idCard">{{ row.cardType | fliterCardType }}</span>
          <span v-else>-</span>
        </template>
        <template v-else-if="item.prop == 'retreatFee'">
          <template v-if="row.status == 60 || row.isTicketChanging == 1">
            <div v-if="row.status == 60">
              <span class="util-money">￥{{ row.retreatFee || 0 }}</span>
              <span v-if="row.refundType == 2"> (平台操作)</span>
              <span v-else> {{
                  row.refundProportion ? "(" + row.refundProportion + "%退票费率" + ")" : "(无退票费)"
                }}</span>

            </div>
            <div v-if="row.isTicketChanging == 1">
              <span class="util-money">￥{{ row.ticketChangingFee || 0 }}</span>
              <span> {{
                  row.ticketChangingProportion ? "(" + row.ticketChangingProportion + "%改签费率" + ")" : "(无改签费)"
                }}</span>
            </div>
          </template>
          <span v-else>-</span>
        </template>
        <template v-else-if="item.prop == 'status'">
          <el-tag size="mini" :type="row.status | filterOrderStatusType">{{ row.status | filterOrderStatus }}</el-tag>
        </template>
        <template v-else-if="item.prop == 'startStationName'">
          <span style="font-weight: 600">{{ row.startStationName }} - {{ row.endStationName }}</span>
        </template>
        <template v-else-if="item.prop == 'vehicleSeat'">{{ row.vehicleSeat }}座</template>
        <template v-else-if="item.prop == 'startLineTime'">
          {{ row.schedulingTime | filterTime("MM-DD") }}
          {{ row.startLineTime }}
        </template>
        <template v-else-if="item.prop == 'channelAlias'">
          <span v-if="mixinUserInfo.platformType === 1">{{ row[item.prop] | filterConst("CHANNELALIAS") }}</span>
          <span v-if="mixinUserInfo.platformType === 2">{{ row[item.prop] | filterConst("CHANNELALIAS2") }}</span>
        </template>
        <template v-else-if="item.prop == 'driverName'">
          <span style="color: #999" v-if="row.status == 5">待指派</span>
          <span v-if="row.status !== 5">{{ row.driverName ? row.driverName : "-" }}</span>
        </template>
        <template v-else-if="item.prop == 'driverPhone'">
          <span style="color: #999" v-if="row.status == 5">待指派</span>
          <span v-if="row.status !== 5">{{ row.driverPhone ? row.driverPhone : "-" }}</span>
        </template>
        <template v-else-if="item.prop === 'loadType'">{{ row.loadType | filterConst('LOADTYPE') }}
        </template>
        <template v-else-if="item.prop == 'realFee'">
          <template v-if="row.realFee || row.realFee == 0">
            <span class="util-money">¥{{ row.realFee }}</span>
            <span v-if="row.couponFee">(优惠券<span class="util-money-minus">-{{ row.couponFee }}</span>)</span>
          </template>
          <span v-if="!row.realFee && row.realFee !== 0">-</span>
        </template>
        <template v-else-if="item.prop == 'lineFee'">
          <span class="util-money" v-if="row.lineFee || row.lineFee == 0">
            {{ row.lineFee + (row.schedulingType == 3 || row.railType == 2 ? "起" : "") }}
          </span>
          <span v-if="!row.lineFee && row.lineFee !== 0">-</span>
        </template>
        <template v-else-if="item.prop == 'score'">
          <el-rate v-model="row.score" disabled></el-rate>
        </template>
        <template v-else-if="item.prop === 'isNewCustomer'">
          <el-tag v-if="row.isNewCustomer === 1" type="success" size="mini">新客</el-tag>
          <el-tag v-else-if="row.isNewCustomer === 2" size="mini">老客</el-tag>
          <span v-else>-</span>
        </template>
        <template v-else-if="item.prop === 'isLocalOrder'">
          <el-tag v-if="row.isLocalOrder === 1" type="primary" size="mini">本地</el-tag>
          <el-tag v-else-if="row.isLocalOrder === 2" type="warning" size="mini">异地</el-tag>
          <span v-else>-</span>
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>

    <orderLineVehicle :visible.sync="reassignmentVisible" :order.sync="order" @confirm="$refs.customTable.listFn()"/>

    <orderLineDetails :visible.sync="detailsVisible" :order.sync="orderView"/>

    <el-dialog title="退票说明" :visible.sync="refundState" width="330px"
               @close="isCustomRule = false; refundFee = null">
      <div :class="{ 'text-disabled': isCustomRule }">
        <div class="cancel-money" v-for="(item, index) in refundRules" :key="index">
          {{ index + 1 }}.检票/接人时间{{ item.timeNum }}{{ item.timeType == 1 ? "小时" : "分钟" }}内办理退票的，按支付金额{{
            item.refundFee
          }}%收取退票费
        </div>
        <div class="cancel-money" style="padding-top: 20px">
          <div class="cancel-money-title">票面金额</div>
          <div class="util-money">￥{{ refundFeeObj.orderFee }}</div>
        </div>

        <div class="cancel-money">
          <div class="cancel-money-title">实付金额</div>
          <div>
            <span v-if="refundFeeObj.couponFee">优惠券-￥{{ refundFeeObj.couponFee }}</span>
            <span class="util-money">￥{{ refundFeeObj.realFee }}</span>
          </div>
        </div>

        <div class="cancel-money">
          <div class="cancel-money-title">退票费用</div>
          <div>
            <span v-if="refundFeeObj.refundProportion">退票费率{{ refundFeeObj.refundProportion }}%</span>
            <span class="util-money">￥{{ refundFeeObj.retreatFee }}</span>
          </div>
        </div>
        <div class="cancel-money">
          <div class="cancel-money-title">实际退款</div>
          <div class="cancel-money-money util-money">
            ￥{{ refundFeeObj.refundFee }}
          </div>
        </div>
      </div>

      <hr style="margin:20px 0">

      <div>
        <div style="display:flex;align-items:center;margin-bottom:10px">
          <el-checkbox v-model="isCustomRule"></el-checkbox>
          <p @click="isCustomRule = !isCustomRule" style="cursor: pointer;margin-left:10px">自定义退票手续费</p>
        </div>
        <el-input v-model="refundFee" placeholder="请输入要扣除的费用" :disabled="!isCustomRule"
                  @input="() => refundFee = refundFee.replace(/^0[\d]/g, '0').replace(/^[1-9][0-9]{4,}/g, '9999').replace(/(\d\d{0,3}\.?\d{0,2})?.*/g, '$1')"></el-input>
        <p style="margin-top:10px;font-size: 14px;color:red">注意：手续费不能大于实际支付金额，可输入0</p>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="cancelConfirm" :loading="loading">确 认</el-button>
        <el-button @click="refundState = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 票据打印 -->
    <el-dialog :visible.sync="printListShow" @close="printList=[]" title="票据打印" width="1000px" append-to-body
               :close-on-click-modal='false' :close-on-press-escape='false'>
      <el-table :data="printList" emptyText="无可打印票据" border style="margin-bottom: 20px;">
        <el-table-column label="票号" prop="ticketNo" width="100"></el-table-column>
        <el-table-column label="线路" prop="startStationName" v-slot="{ row }">
          {{ row.startStationName + ' - ' + row.endStationName }}
        </el-table-column>
        <el-table-column label="票价" prop="ticketFee" width="60"></el-table-column>
        <el-table-column label="乘车日期" prop="schedulingTime" width="100" v-slot="{ row }">
          {{ row.schedulingTime | filterTime('YYYY-MM-DD') }}
        </el-table-column>
        <el-table-column label="开车时间" prop="startLineTime" width="70"></el-table-column>
        <el-table-column label="车次" prop="licenseNo" width="100"></el-table-column>
        <el-table-column label="乘客" prop="customerName" width="70"></el-table-column>
        <el-table-column label="车票类型" prop="ticketType" width="70" v-slot="{ row }">
          {{ row.ticketType | filterConst('TICKETTYPE') }}
        </el-table-column>
        <el-table-column label="座号" prop="seatNo" width="50"></el-table-column>
        <el-table-column fixed="right" label="操作" width="80" v-slot="{ row }" align="center">
          <el-button type="text" size="small" @click="print(row)">打印</el-button>
          <!--          <el-button type="text" size="small" @click="cancellation(row)">作废</el-button>-->
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="乘客信息" :visible.sync="orderCustomersShow" width="850px" @close="orderCustomersShow = false">
      <el-table :data="orderCustomers" stripe border style="margin-bottom: 20px;">
        <el-table-column prop="customerName" label="乘客姓名" width="140" v-slot="{ row }">
          {{ row.customerName }}
          <el-tag v-if="row.isDefault == 1" effect="plain">联系人</el-tag>
        </el-table-column>
        <el-table-column prop="idCard" label="证件号码" min-width="160"></el-table-column>
        <el-table-column prop="cardType" label="证件类型" min-width="120" v-slot="{ row }">{{ row.cardType | fliterCardType }}</el-table-column>
        <el-table-column prop="customerPhone" label="乘客电话" min-width="120"></el-table-column>
        <el-table-column prop="ticketType" label="车票类型" min-width="100" v-slot="{row}"
                         v-if="mixinUserInfo.platformType === 2">
          {{ ['全票', '半价票', '免票(占座)', '免票(不占座)'][row.ticketType - 1] }}
        </el-table-column>
        <el-table-column width="80" show-overflow-tooltip v-if="mixinUserInfo.platformType === 2" prop="ticketNo"
                         label="票号"></el-table-column>
      </el-table>
    </el-dialog>


    <!-- 票据选择 -->
    <el-dialog :visible.sync="billDialogVisible" title="票据选择" width="600px" :show-close="false" append-to-body
               :close-on-click-modal='false' :close-on-press-escape='false'>
      <div style="width: 100%">
        <el-button :loading="loading" style="margin-bottom: 20px;" icon="el-icon-refresh"
                   @click="getBillListFn"></el-button>

        <el-table v-loading="loading" style="width: 100%;margin-bottom: 20px;" :data="billList" emptyText="无可票据选择"
                  border>
          <el-table-column label="当前票号" prop="ticketCurrentNo"></el-table-column>
          <el-table-column label="剩余张数" prop="remainingNum"></el-table-column>
          <el-table-column label="入库时间" prop="created" v-slot="{ row }">
            {{ row.created | filterTime('YYYY-MM-DD') }}
          </el-table-column>

          <el-table-column fixed="right" label="操作" width="100" v-slot="{ row,$index }">
            <el-checkbox @change="checkboxChangeFn(row,$index)" v-model="row.checkboxStatus"></el-checkbox>
          </el-table-column>
        </el-table>

      </div>
      <div style="display: flex;justify-content: flex-end">
        <el-button @click="billDialogVisible  = false">取消</el-button>
        <el-button @click="billClickFn" :loading="billLoading" type="primary">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import orderLineDetails from "./orderLineDetails";
import orderLineVehicle from "./orderLineVehicle";


const columns1 = [
  {prop: "orderNo", label: "订单号", width: 190},
  {prop: "status", label: "订单状态", width: 80},
  {prop: "channelAlias", label: "订单来源", width: 70},
  {prop: "created", label: "下单时间", width: 130},
  {prop: "finishTime", label: "完成/取消时间", width: 130},
  {prop: "lineName", label: "线路", width: 160},
  {prop: "organizationName", label: "机构名称", width: 120},
  {prop: "startStationName", label: "线路名称", minWidth: 200},
  {prop: "startLineTime", label: "班次", width: 140},
  {prop: "customerName", label: "乘客", width: 90},
  {prop: "isNewCustomer", label: "新老客", width: 80},
  {prop: "isLocalOrder", label: "本地/异地", width: 90},
  {prop: "orderLocationCity", label: "下单城市", width: 100},
  {prop: "orderLocationCountry", label: "下单国家", width: 100},
  {prop: "cardType", label: "证件类型", width: 160},
  {prop: "idCard", label: "证件号码", width: 150},
  {prop: "customerPhone", label: "联系电话", width: 110},
  {prop: "passengerNum", label: "乘客数", width: 80},
  {prop: "lineFee", label: "车票价格", width: 80},
  {prop: "realFee", label: "实付金额", width: 130},
  {prop: "retreatFee", label: "退改金额", width: 130},
  {prop: "licenseNo", label: "车辆号牌", width: 120},
  {prop: "vehicleNo", label: "车辆编号", width: 100},
  {prop: "driverName", label: "司机姓名", width: 80},
  {prop: "driverPhone", label: "司机电话", width: 105},
  {prop: "score", label: "评分", width: 140},
]

const columns2 = [
  {prop: "orderNo", label: "订单号", width: 190},
  {prop: "status", label: "订单状态", width: 80},
  {prop: "loadType", label: "检票状态", width: 105},
  {prop: "channelAlias", label: "订单来源", width: 70},
  {prop: "created", label: "下单时间", width: 130},
  {prop: "finishTime", label: "完成/取消时间", width: 130},
  {prop: "lineName", label: "线路", width: 160},
  {prop: "organizationName", label: "机构名称", width: 120},
  {prop: "startStationName", label: "线路名称", minWidth: 200},
  {prop: "startLineTime", label: "班次", width: 90},
  {prop: "customerName", label: "乘客", width: 90},
  {prop: "isNewCustomer", label: "新老客", width: 80},
  {prop: "isLocalOrder", label: "本地/异地", width: 90},
  {prop: "orderLocationCity", label: "下单城市", width: 100},
  {prop: "orderLocationCountry", label: "下单国家", width: 100},
  {prop: "cardType", label: "证件类型", width: 160},
  {prop: "idCard", label: "证件号码", width: 150},
  {prop: "customerPhone", label: "联系电话", width: 110},
  {prop: "passengerNum", label: "乘客数", width: 80},
  {prop: "lineFee", label: "车票价格", width: 80},
  {prop: "realFee", label: "实付金额", width: 130},
  {prop: "retreatFee", label: "退改金额", width: 130},
  {prop: "licenseNo", label: "车辆号牌", width: 120},
  {prop: "vehicleNo", label: "车辆编号", width: 100},
  {prop: "driverName", label: "司机姓名", width: 80},
  {prop: "driverPhone", label: "司机电话", width: 105},
  {prop: "ticketSeller", label: "售票员", width: 105},
  {prop: "ticketNo", label: "票号", width: 105},
  {prop: "openOrderNo", label: "三方订单号", width: 105},
]


export default {
  name: "order",
  components: {orderLineDetails, orderLineVehicle},

  data() {
    return {

      tabAction: "all",
      loading: false,
      isCustomRule: false,
      refundFee: null,
      refundRules: [],
      refundFeeObj: {},
      refundState: false,
      channelAlias: '',


      // 配置项
      customOptions: {
        // 请求的列表url
        url: '/api/v1/manage/order',
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
          orderType: 4,

        },
        search: [
          {type: "input", field: "orderNo", name: "订单号", value: ""},
          {type: "input", field: "startStationName", name: "出发地", value: ""},
          {type: "input", field: "endStationName", name: "目的地", value: ""},
          {type: "input", field: "licenseNo", name: "车辆号牌", value: ""},
          {type: "input", field: "vehicleNo", name: "车辆编号", value: ""},
          {type: "input", field: "customerPhone", name: "联系电话", value: ""},

          {type: "input", field: "driverName", name: "司机姓名", value: ""},
          {type: "input", field: "driverPhone", name: "司机电话", value: ""},
          {
            type: "select", field: "createdOrFinishTimeSort", name: "数据排序", value: null,
            option: [
              {value: null, label: "全部"},
              {value: 1, label: "下单时间正序排序"},
              {value: 2, label: "下单时间倒序排序"},
              {value: 3, label: "完成/取消时间正序排序"},
              {value: 4, label: "完成/取消时间倒序排序"},
            ],
          },
          {
            type: "select", field: "channelAlias", name: "下单渠道", value: null,
            option: [
              {value: null, label: '全部'},
              {value: 'system_order', label: '后台'},
              {value: 'channel_wechat', label: '小程序'},
              {value: 'channel_fast_order', label: '极速购票'},
              {value: 'channel_driver_order', label: '司机'},

              {value: 'station_order', label: '联网售票'},
              {value: 'mobile_ticketing_order', label: '移动售票'},
              {value: 'tc_order', label: '同程'},

            ]
          },
          {type: "datetime", field: "time", name: "下单时间",  value: [new Date().setHours(0, 0, 0, 0) - 3600 * 1000 * 24 * 30, new Date().setHours(23, 59, 59, 0)], defaultDays: 30},
          {
            type: "datetime",
            field: "finishTime",
            dateProp: {start: "finishStartTime", end: "finishEndTime"},
            name: "完成/取消时间",
            value: []
          },
          {
            type: "select", field: "isNewCustomer", name: "新老客", value: null,
            option: [
              {value: 1, label: "新客"},
              {value: 2, label: "老客"},
            ],
          },
          {
            type: "select", field: "isLocalOrder", name: "本地/异地", value: null,
            option: [
              {value: 1, label: "本地"},
              {value: 2, label: "异地"},
            ],
          },
          {type: "input", field: "orderLocationCity", name: "下单城市", value: ""},
        ],
      },
      // 表头
      columns: [],
      // 状态
      status: null,
      schedulingType: '',
      order: {},
      orderView: {},
      reassignmentVisible: false,
      detailsVisible: false,

      orderCustomersShow: false,
      orderCustomers: [],

      printListShow: false,
      printList: [],
      printRow: {},

      billList: [],
      billForm: {},
      billLoading: false,
      printRowId: '',
      billDialogVisible: false,
    };
  },
  watch: {
    tabAction(val) {
      this.customOptions.params.loadType = null
      this.customOptions.params.status = null

      this.customOptions.params.page = 1;
      this.customOptions.params.status = val != "all" ? val : null;
      if (this.tabAction === 10) {
        this.customOptions.params.status = null
        this.customOptions.params.loadType = 1
      } else if (this.tabAction === 3) {
        this.customOptions.params.status = null
        this.customOptions.params.loadType = 3
      }

      this.$refs.customTable.listFn();
    },
  },
  created() {
    this.columns = this.mixinUserInfo.platformType === 2 ? columns2 : columns1

    this.customOptions.params.platformType = this.mixinUserInfo.platformType

    if (this.mixinUserInfo.platformType === 2) {
      console.log(this.customOptions.search[9], 111);
      this.customOptions.search[9].option[1].label = '窗口售票'

      this.customOptions.search.push({
        type: "select", field: "ticketSellerId", name: "售票员", value: null,
        props: {label: 'name', value: 'id',},
        option: []
      })
      this.customOptions.search.push({
        type: "input", field: "ticketNo", name: "票号", value: null,
      })
    }

    if (this.mixinUserInfo.platformType === 2) {
      this.customOptions.search.splice(1, 2, {
        type: "select", field: "lineId", name: "搜索线路", value: null,
        filterable: true,
        props: {label: 'stationName', value: 'id',},
        option: []
      })


      this.customOptions.search.splice(4, 0, {
        type: "input",
        field: "customerName",
        name: "联系人姓名",
        value: ""
      }, {type: "input", field: "idCard", name: "乘客证件号码", value: ""},)
    }

    if (this.$route.query.status) {
      this.customOptions.params.status = this.$route.query.status;
      this.tabAction = this.customOptions.params.status;
    }
  },
  methods: {
    async billClickFn() {
      const status = this.billList.some((item) => item.checkboxStatus)
      if (!status) {
        this.$message.warning('请选择作废的票号')
        return
      }
      this.billLoading = true
      const url = '/api/v1/manage/order/ticket/cancellation'
      const {code} = await this.$axios.post(url, this.billForm)
      this.billLoading = false
      if (code === 1) {
        this.billDialogVisible = false
        this.billForm = {}
        this.$message.success("操作成功");
        this.printClick({id: this.printRowId})
      }

    },
    checkboxChangeFn(row, num) {
      this.billForm.ticketCurrentNo = row.ticketCurrentNo
      this.billForm.ticketReceiveId = row.id
      this.billList = this.billList.map((item, index) => {
        return {
          ...item,
          checkboxStatus: index === num
        }
      })
    },
    cancellation(row) {
      this.billForm = {
        orderId: row.orderId,
        ticketNo: row.ticketNo
      }
      this.billDialogVisible = true
      this.getBillListFn()
    },
    async getBillListFn() {
      this.loading = true
      const {code, data} = await this.$axios.get('/api/v1/manage/order/manage/ticket', {
        page: 1,
        size: 999, // 每页条数
      })
      this.loading = false
      if (code === 1 && data) {
        this.billList = data.map((item) => ({...item, checkboxStatus: false}))
      }
    },
    /**
     * 状态改变
     */
    schedulingTypeChange(val) {
      this.customOptions.params.page = 1;
      this.customOptions.params.schedulingType = val;
      this.$refs.customTable.listFn();
    },
    channelAliasChange() {
      this.customOptions.params.channelAlias = this.channelAlias
      this.$refs.customTable.listFn()
    },
    // 查看乘客
    async handleConnectionSearch(row) {
      let url = "/api/v1/manage/order/orderCustomer/customer/" + row.id;
      let data = await this.$axios.get(url);
      if (data && data.code == 1) {
        if (data.data.length == 0) {
          this.$message.warning("没有找到相关乘客");
        } else {
          this.orderCustomers = data.data;
          this.orderCustomersShow = true;
        }
      }
    },
    // 查询订单乘客列表
    async loadChildren(tree, treeNode, resolve) {
      let url = "/api/v1/manage/order/orderCustomer/customer/" + tree.id;
      let data = await this.$axios.get(url);
      if (data && data.code == 1) {
        if (data.data.length == 0) {
          this.$message.warning("没有找到相关乘客");
        } else {
          for (const item of data.data) {
            if (item.isDefault == 1) {
              continue;
            } else {
              item.id = 9999999;
            }
          }
          resolve(data.data);
        }
      } else {
        this.$message.error("查询错误");
        resolve([{msg: "接口错误"}]);
      }
    },
    async getRefundRules() {
      let url = "/api/v1/manage/order/refund/" + +this.order.id;
      let data = await this.$axios.get(url);
      if (data && data.code == 1) {
        this.refundRules = data.data || [];
      }
    },
    async getRefundFeeObj() {
      let url = "/api/v1/manage/order/getRefundFee/" + +this.order.id;
      let data = await this.$axios.get(url);
      if (data && data.code == 1) {
        this.refundFeeObj = data.data || [];
        return true;
      } else {
        return false;
      }
    },
    reassignmentClick(row) {
      this.order = row;
      this.reassignmentVisible = true;
    },
    /* 点击票据列表 */
    async printClick(row) {
      this.printRowId = row.id
      this.printListShow = true;
      let url = "/api/v1/manage/order/ticket/print/" + row.id;
      let data = await this.$axios.get(url);
      if (data?.code == 1 && data.data && data.data.length > 0) {
        this.printList = data.data;
      }
    },
    /* 打印发票 */
    print(row) {
      this.printRow = row;
      this.$nextTick(() => {
        const printContentHtml = document.getElementById("print").innerHTML;
        const iframe = document.createElement("iframe");
        document.body.appendChild(iframe);
        iframe.contentDocument.write(printContentHtml);
        iframe.contentDocument.close();
        iframe.contentWindow.print();
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 2000);
      })
    },
    /* 取消订单 */
    async cancelClick(row) {
      this.order = row;
      let res = await this.getRefundFeeObj();
      if (!res) {
        return;
      }
      await this.getRefundRules();
      if (this.refundRules && this.refundRules.length > 0) {
        this.refundState = true;
      } else {
        this.$confirm("确认要取消本订单吗?", "退票提示").then(async () => {
          this.postCancel();
        });
      }
    },
    async cancelConfirm() {
      if (this.isCustomRule) {
        if (this.refundFee.trim() == '') {
          this.$message.warning({
            message: '请输入要扣除的费用'
          });
          return;
        }
      }
      this.loading = true;
      await this.postCancel();
      this.loading = false;
    },
    async postCancel() {
      let params = {};
      if (this.isCustomRule) {
        params.refundFee = this.refundFee;
      }
      let url = "/api/v1/manage/order/cancel/" + this.order.id;
      let data = await this.$axios.post(url, params);
      if (data && data.code == 1) {
        this.$message.success("操作成功");
        this.$refs.customTable.listFn();
        this.refundState = false;
      }
    },
  },
};
</script>

<style lang="less">
#order {
  .el-radio-group {
    .el-radio-button__inner {
      font-size: 13px;
    }
  }

  .el-dialog {
    .customTable-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .dialog-line-list {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .el-tabs {
      .el-tabs__header {
        margin: 0;
      }

      .el-tabs__nav-wrap::after {
        background-color: transparent;
    }
    }

    .el-dialog__body {
      padding-top: 10px;
    }

    .dialog-top {
      display: flex;
      line-height: 28px;
      font-size: 14px;
      margin-bottom: 12px;

      .dialog-top-item + .dialog-top-item {
        margin-left: 16px;
      }

      .line-name {
        width: 300px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .dialog-table {
      overflow: auto;
    }

    .table-operation-choose {
      cursor: pointer;
      color: @color-primary;
    }
  }

  .cancel-money {
    display: flex;
    justify-content: space-between;

    .cancel-money-title {
      font-weight: 600;
    }

    .cancel-money-money {
      font-weight: 600;
    }

    .util-money {
      padding-left: 8px;
    }
  }

  .cancel-money + .cancel-money {
    padding-top: 14px;
  }

  .el-table__expand-icon {
    display: none;
  }
}
</style>
